<template>
  <div>
    <el-input
      class="my_input"
      :placeholder="placeholder"
      v-model="searchValue"
      :size="size"
      clearable
      @focus="focusFunc"
      @blur="blurFunc"
      @clear="searchFunc"
      @keyup.enter.native="searchFunc"
    >
    <i ref="icon" slot="suffix" class="el-input__icon el-icon-search" @click="searchFunc"></i>
    </el-input>
  </div>
</template>

<script>
export default {
  name: "n_searchInput",
  components: {},
  props: {
    placeholder: {
      type: String,
      default: "搜索"
    },
    size: {
      type: String,
      default: "small"
    },
    value: {
      type: String,
      default: ""
    },
  },
  data() {
    return {
      searchValue: this.value,
    };
  },
  created() {},
  mounted() {},
  methods: {
    focusFunc() {
      this.$refs.icon.style.color = '#1890FF';
    },
    blurFunc() {
      this.$refs.icon.style.color = '#C0C4CC';
    },
    searchFunc() {
      this.$emit("searchInput", this.searchValue)
    }
  },
  watch: {
    value(newVal) {
      this.searchValue = newVal
    },
    searchValue(newVal) {
      this.$emit('input', newVal)
    }
  }
};
</script>

<style scoped lang="scss">
.my_input {
  /deep/ .el-input__inner {
    &:focus {
      border: 1px solid #1890FF;
    }
  }
  /deep/ .el-input__suffix {
    cursor: pointer;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/szrt_revision/components/n_searchInput.vue